import { PRODUCT_REVIEW_REWARD_TYPE } from '../constants/productReview';

app.directive('productReviewEntry', [
  '$location',
  'slFeatureService',
  'productReviewCommentService',
  'mainConfig',
  '$q',
  '$filter',
  function (
    $location,
    slFeatureService,
    productReviewCommentService,
    mainConfig,
    $q,
    $filter,
  ) {
    return {
      templateUrl: require('../../../../../public/themes/shared/product_review_comments/templates.product_review_entry.html'),
      restrict: 'E',
      scope: false,
      link: function (scope) {
        if (!productReviewCommentService.productReviewEnabled) {
          return;
        }

        scope.productReviewUrl =
          '/users/' +
          mainConfig.currentUser._id +
          '/product_review_comments/orders';

        scope.isDataLoaded = false;
        scope.hasUncommentedOrder = false;
        scope.productReviewRewardType = null;
        scope.productReviewRewardRule = null;

        const getUncommentedOrderAmount = function () {
          // Do not show product review entry at last step of checkout flow
          if ($location.url().includes('/confirm')) {
            return $q.resolve();
          }

          return productReviewCommentService
            .getUncommentedOrders({
              page: 1,
              limit: 1,
            })
            .then((res) => {
              scope.hasUncommentedOrder = res.data.data['total'] > 0;
              return res;
            });
        };

        const getProductReviewRewardConfig = () => {
          if (!slFeatureService.hasFeature('product_review_reward')) {
            return $q.resolve();
          }

          return productReviewCommentService
            .getProductReviewRewardConfig()
            .then(({ rewardType, rule }) => {
              scope.productReviewRewardType = rewardType;
              scope.productReviewRewardRule = rule;
            });
        };

        const fetchData = () => {
          $q.all([getUncommentedOrderAmount(), getProductReviewRewardConfig()])
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {
              scope.isDataLoaded = true;
            });
        };
        fetchData();

        scope.getTitle = () => {
          switch (scope.productReviewRewardType) {
            case PRODUCT_REVIEW_REWARD_TYPE.user_credit:
              return $filter('translate')(
                'product_review_entry.review_description_title.user_credit',
                {
                  value: scope.productReviewRewardRule.credit_value,
                },
              );
            case PRODUCT_REVIEW_REWARD_TYPE.member_point:
              return $filter('translate')(
                'product_review_entry.review_description_title.member_point',
                {
                  value: scope.productReviewRewardRule.point_value,
                },
              );
            case null:
            default:
              return $filter('translate')(
                'product_review_entry.review_description_title',
              );
          }
        };
      },
    };
  },
]);
